export const SET_CURRENT_CUSTOMER = "state/pages/customer/SET_CURRENT_CUSTOMER";
